export default {
    share: {
        copySuccess: '复制成功'
    }
};


